import Form from 'app/components/Form';

import {
  createBillingExportSched,
  updateBillingExportSched
} from 'app/services/billings';

import {
  getAccounts
} from 'app/services/accounts';

import {
  formatOptions,
  scheduleOptions,
  createOption
} from 'app/utils/options';

const BillingExportScheduleForm = props => {
  const {
    exportSched,
    onClose,
    onSubmit,
    action
  } = props;

  const header = 'Export Schedule';

  const getAccountOptions = async (page = 1, perPage = 100, filter = null, id = null) => {
    let params = {
      page,
      per_page: perPage,
      record_id: id
    }

    if (filter) {
      params.filter_model = {
      name: [{
        filterClass: 'text',
        filterType: 'contains',
        value: filter
      }]
      }
    }

    let resp = await getAccounts(params);
    let accountOptions = formatOptions(resp.records)
    accountOptions.unshift(createOption('All Accounts', -1));

    return accountOptions;
  }

  let fields = [
    { name: 'export_name', label: 'Export Name', type: 'text', value: exportSched?.export_name },
    { name: 'email', label: 'Notify Email', type: 'text', value: exportSched?.email },
    { name: 'account_id', label: 'Account', type: 'autocomplete', value: exportSched?.account_id, valueType: 'integer', getOptions: getAccountOptions },
    { name: 'schedule_type', label: 'Schedule Type', type: 'select', value: exportSched?.schedule_type, valueType: 'string', options: scheduleOptions },
    { name: 'start_date', label: 'Start Date', type: 'datetime', value: exportSched?.start_date },
    { name: 'end_date', label: 'End Date', type: 'datetime', value: exportSched?.end_date },
  ]

  return (
    <Form {...{
      header,
      fields,
      action,
      onClose,
      onSubmit
    }} />
  );
}

export default BillingExportScheduleForm;
